import requestModule from '../libs/requestModule'
import Util from '@/assets/libs/util.js'

const CRMBonusParams = {
    apiUrlCRM: Util.getLocalConfigs('apiUrlCRM'),
    authCRM: Util.getLocalConfigs('authCRM'),
    companyCodCRM: Util.getLocalConfigs('companyCodCRM')
}

// Events
const GET_BALANCE = CRMBonusParams.apiUrlCRM + '/getBalance'
const ADD_TOTAL_SALES = CRMBonusParams.apiUrlCRM + '/addTotalSales'
const BONUS_PROCESSING = CRMBonusParams.apiUrlCRM + '/bonusProcessing'
const CALCEL_BONUS = CRMBonusParams.apiUrlCRM + '/cancelBonus'
const PIN_VALIDATION_STATUS = CRMBonusParams.apiUrlCRM + '/getPinValidationStatus'
const VALIDATE_PIN = CRMBonusParams.apiUrlCRM + '/validatePin'
const RESEND_PIN = CRMBonusParams.apiUrlCRM + '/resendPin'

let bonusCRMBalance = null
let bonusProcessingData = null

const getCRMStatus = async function () {
    /* Verifica a API do crm bonus esta paramtrizada e válida */
    let crmEnabled = (!!CRMBonusParams.apiUrlCRM && !!CRMBonusParams.authCRM && !!CRMBonusParams.companyCodCRM)
    if (crmEnabled) {
        const CRMStatus = await requestModule.xmlRequest(CRMBonusParams.apiUrlCRM, 'get', null, null)
            .then(r => r && r.root && r.root.data)
            .catch((e) => {
                console.log(e)
                return { error: true, message: e }
            })
        if (CRMStatus && CRMStatus.version && !CRMStatus.error) {
            return true
        }
    }
    return false
}

async function getCRMBalance (value, phone) {
    const params = buildRequest()
    params.root.data.order = {
        phone: phone.replace('+', ''),
        value: value
    }
    const result = await requestModule.xmlRequest(GET_BALANCE, 'post', params)
    if (!result || result.error || !result.root || !result.root.data) {
        console.log('Falha ao obter o ballance do CRM Bonus')
        console.log(getResultErrorMessage(result))
        return null
    }
    bonusCRMBalance = result && result.root && result.root.data
    return bonusCRMBalance
}

async function addTotalSaleCRM (bonusId, orderIdCRM, phone, totalSaleValue) {
    const params = buildRequest()
    params.root.data.order = {
        name: null,
        phone: phone.replace('+', ''),
        value: totalSaleValue,
        bonusId: bonusId,
        orderIdCRM: orderIdCRM,
        nfceCode: null
    }
    const result = await requestModule.xmlRequest(ADD_TOTAL_SALES, 'post', params)
    if (!result || result.error || !result.root || !result.root.data) {
        console.log('Falha ao processar o CRM bonus')
        console.log(getResultErrorMessage(result))
        throw new Error('Falha na rotina addTotalSaleCRM CRM BONUS')
    }
    return result && result.root && result.root.data
}

async function applyCRMDiscount (saleData, phone, totalSaleValue, discount) {
    if (!saleData || !bonusCRMBalance || !bonusCRMBalance.bonusId) {
        console.log('nao foram recebido todos os parametros necessarios para aplicar o desconto')
        return false
    }
    const params = buildRequest()
    params.root.data.order = {
        name: null,
        phone: phone.replace('+', ''),
        value: totalSaleValue,
        type: discount ? 'R' : 'G',
        bonusId: bonusCRMBalance.bonusId._text,
        bonusUsed: discount,
        saleCode: saleData.saleSeq,
        nfceCode: saleData.nfceCode
    }
    const result = await requestModule.xmlRequest(BONUS_PROCESSING, 'post', params)
    if (!result || result.error || !result.root || !result.root.data) {
        console.log('Falha ao processar o CRM bonus')
        console.log(getResultErrorMessage(result))
        return null
    }
    bonusProcessingData = result && result.root && result.root.data
    return bonusProcessingData
}

const cancelCRMDiscount = async function (saleData) {
    const params = buildRequest()
    params.root.data.order = {
        bonusId: bonusProcessingData.bonusId._text,
        nfceCode: saleData.nfceCode || null
    }
    const result = await requestModule.xmlRequest(CALCEL_BONUS, 'post', params)
    return result && result.root && result.root.data
}

const getPinValidationStatus = async function (phone) {
    const params = buildRequest()
    params.root.data.phone = phone
    const result = await requestModule.xmlRequest(PIN_VALIDATION_STATUS, 'post', params)
    return result && result.root && result.root.data
}

const validatePin = async function (data = {}) {
    const params = buildRequest()
    params.root.data = Object.assign(params.root.data, data)
    const result = await requestModule.xmlRequest(VALIDATE_PIN, 'post', params)
    return result && result.root && result.root.data
}

const resendPin = async function (data) {
    const params = buildRequest()
    params.root.data = Object.assign(params.root.data, data)
    const result = await requestModule.xmlRequest(RESEND_PIN, 'post', params)
    return result && result.root && result.root.data
}

function buildRequest () {
    const params = { root: { data: {} } }
    params.root.data.companyCode = CRMBonusParams.companyCodCRM
    params.root.data.authorization = CRMBonusParams.authCRM
    return params
}

function getResultErrorMessage (result) {
    let errorMessage = (result && result.message && result.message.root && result.message.root.message && result.message.root.message._text) ||
    result.message || null
    return errorMessage
}

export default {
    getCRMStatus,
    getCRMBalance,
    addTotalSaleCRM,
    applyCRMDiscount,
    cancelCRMDiscount,
    clearCRMData: () => {
        bonusCRMBalance = null
        bonusProcessingData = null
    },
    getCRMBonusBalance: () => {
        if (bonusCRMBalance && bonusCRMBalance.balance && bonusCRMBalance.balance._text) {
            return {
                available: parseFloat(bonusCRMBalance.balance._text),
                maxValue: parseFloat(bonusCRMBalance.balance._text)
            }
        }
        return {
            available: 0,
            maxValue: 0
        }
    },
    getPinValidationStatus,
    validatePin,
    resendPin
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CampaignFidelityCrmBonusController.js